"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var LedgerLinePostingStatusEnum;
(function (LedgerLinePostingStatusEnum) {
    LedgerLinePostingStatusEnum["Success"] = "success";
    LedgerLinePostingStatusEnum["Resolved"] = "resolved";
    LedgerLinePostingStatusEnum["Error"] = "error";
    LedgerLinePostingStatusEnum["InProgress"] = "in_progress";
    LedgerLinePostingStatusEnum["NotStarted"] = "not_started";
    LedgerLinePostingStatusEnum["NothingToPost"] = "nothing_to_post";
})(LedgerLinePostingStatusEnum = exports.LedgerLinePostingStatusEnum || (exports.LedgerLinePostingStatusEnum = {}));
function LedgerLinePostingFromJSON(json) {
    return LedgerLinePostingFromJSONTyped(json, false);
}
exports.LedgerLinePostingFromJSON = LedgerLinePostingFromJSON;
function LedgerLinePostingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'site_id': json['site_id'],
        'created_at': (new Date(json['created_at'])),
        'integration': json['integration'],
        'integration_name': json['integration_name'],
        'integration_is_async': !runtime_1.exists(json, 'integration_is_async') ? undefined : json['integration_is_async'],
        'status': json['status'],
        'payable': _1.PayableSummaryFromJSON(json['payable']),
        'causer': _1.CauserSummaryFromJSON(json['causer']),
        'last_error': !runtime_1.exists(json, 'last_error') ? undefined : json['last_error'],
        'last_error_at': !runtime_1.exists(json, 'last_error_at') ? undefined : (new Date(json['last_error_at'])),
        'succeeded_at': !runtime_1.exists(json, 'succeeded_at') ? undefined : (new Date(json['succeeded_at'])),
        'lines': (json['lines'].map(_1.LedgerLineFromJSON)),
    };
}
exports.LedgerLinePostingFromJSONTyped = LedgerLinePostingFromJSONTyped;
function LedgerLinePostingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'site_id': value.site_id,
        'created_at': (value.created_at.toISOString()),
        'integration': value.integration,
        'integration_name': value.integration_name,
        'integration_is_async': value.integration_is_async,
        'status': value.status,
        'payable': _1.PayableSummaryToJSON(value.payable),
        'causer': _1.CauserSummaryToJSON(value.causer),
        'last_error': value.last_error,
        'last_error_at': value.last_error_at === undefined ? undefined : (value.last_error_at.toISOString()),
        'succeeded_at': value.succeeded_at === undefined ? undefined : (value.succeeded_at.toISOString()),
        'lines': (value.lines.map(_1.LedgerLineToJSON)),
    };
}
exports.LedgerLinePostingToJSON = LedgerLinePostingToJSON;
